import api from "./api";

//根据打卡活动Id查询已添加的商品
export const getSearchAddedGoods = (id) => {
  return api("get", `/v1/management/equipment-task-clock/equipmentByTaskClockId/${id}`);
}

//打卡活动商品列表展示
export const postActivityGoodsList = (params) => {
  return api("post", `/v1/management/equipment-task-clock/list`, params);
}

//保存打卡活动商品
export const postPreserveActivityGoods = (params) => {
  return api("post", `/v1/management/equipment-task-clock/saveEquipment`, params);
}
